import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ComponentImage from "GeneralComponents/ComponentImage";
import LimitedContent from "GeneralComponents/LimitedContent";
import BannerItem from "../Banner.interface"
import { MediaItem } from "Interfaces/general.interface";

import "./ChangingContentBanner.css";
const mediaType = window.matchMedia("(min-width: 1300px)");


export default class ChangingContentBannerItem extends Component {

    props: any;

    state: BannerItem;



    constructor(props) {
        super(props);

        this.state = {

            index: this.props.bannerItem.index,
            title: this.props.bannerItem.title,
            content: this.props.bannerItem.content,
            url: this.props.bannerItem.url,
            link: this.props.bannerItem.link,
            icon: this.props.bannerItem.icon,
            imageOrMovie: this.props.bannerItem.imageOrMovie as MediaItem,
            mobileImageOrMovie: this.props.bannerItem.mobileImageOrMovie as MediaItem,
            specialTextAlign: this.props.bannerItem.specialTextAlign,
            lightShadowColor: this.props.bannerItem.lightShadowColor,
            noShadow: this.props.bannerItem.noShadow,
            oneSize: false
        };
    }

    render() {
        
        return (


            <div className={`flex-row mst-Banner-Content mst-ChangingContentBanner ${this.state.lightShadowColor ? ' lightShadow' : ' darkShadow'} ${this.state.noShadow ? ' noShadow' : ''} ${this.state.specialTextAlign ? ' aliginRight' : ' '}`}>



                {this.state.imageOrMovie.url && <ComponentImage
                    image={this.state.imageOrMovie}
                    imageClass="img-fluid"
                    mobileImage={this.state.mobileImageOrMovie}
                    mobileImageClass="img-fluid"
                    wrapperDivClass="mst-Banner-Image mst-ChangingContentBanner-Image"
                    cancelVideoLoop={this.props.cancelVideoLoop}
                    onVideoEnded={this.props.onVideoEnded }
                />

                }




                <div className={`my-auto  mst-ChangingContentBanner-Box ${this.state.specialTextAlign ? ' aliginRight ' : ''} `}>
                    <div id={"carouselContentControls-" + this.state.index} className="outline-none">
                        <h2 className="mst-banner-title mb-3">
                            {this.state.title}
                        </h2>
                        <div className="mst-Content">

                            <div className="mst-ChangingContentBanner-Text mst-rich-desc-field content-txt px-2 px-lg-0 limited-content" dangerouslySetInnerHTML={{ __html: this.state.content }} />

                            
                            
                            {/* <LimitedContent classNames="mst-ChangingContentBanner-Text mst-rich-desc-field content-txt px-2 px-lg-0 " htmlContent={this.state.Content}></LimitedContent>*/}
                        </div>

                        {
                            (this.state.url || this.state.link) &&
                            <div className="content-txt  mst-ChangingContentBanner-BtnLink mt-3 " >

                                <CustomLinkButton
                                    title={this.state.title}
                                    pageUrl={this.state.url}
                                    link={this.state.link}
                                    isBtn={true}
                                    btnClass={"btn mst-btn btn-primary px-2 px-md-auto"}
                                    linkClass={""}
                                    dir={this.props.dir}
                                    linkIcon={true}
                                    charLimit={28}
                                />


                            </div>
                        }


                    </div>

                </div>



            </div>

        );
    }
}
